export const regexes = {
  birthDate: /^(((0?[1358]|1[02])\/(0?[1-9]|[12][0-9]|3[01]))|((0?[4679]|11)\/(0?[1-9]|[12][0-9]|30|31))|((0?2\/(0?[1-9]|[12][0-9]))))$/,
  cityState: /^[A-Za-z, '".]+$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  iso8601: /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-](?:(?:0\d|1[0-3]):?[0-5]\d|14:?00))?)$/,
  leadingTrailingSlashes: /^\/+|\/+$/g,
  mfa: /^\d{6}$/,
  numeric: /^\d+$/,
  password: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/,
  phone: /^(\d{0,3})(\d{0,3})(\d{0,4})$/,
  phoneFormatted: /^\(\d{3}\) \d{3}-\d{4}$/,
  phoneValidation: /^[0-9]{3}[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/,
  timeRegex: /^([0-9]|0[1-9]|1[0-2]):[0-5][0-9]$/,
  zipCode: /^(\d{5}-\d{4}|\d{5}|\d{9})$|^([a-zA-Z]\d[a-zA-Z] \d[a-zA-Z]\d)$/,
} as const;
